export default __webpack_public_path__ + "static/media/video-horizontal-background-0003.fa4216b5.jpg";